import React from "react";
import block from "bem-cn";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

import BackBlock from "components/BackBlock";
import SVG from "components/SVG";

import exclamationSVG from './img/exclamation.svg';

import './SuccesMessage.scss';

const b = block('succes-message');
const SuccesMessage = () => {
  const { search } = useLocation();
  const locale = useSelector(state => state.locale.locale);
  const status = new URLSearchParams(search).get('status'); // 'Created', 'Fail', 'Cancel'
  const message = locale.statuses[status] || locale.statuses['Fail'];

  return (
    <div className={b()}>
      <BackBlock route="/paymentSuAdmin" />
      <div className={b('content')}>
        <div className={b('icon-wrapper')}>
          <SVG className={b('icon')} svgProps={{ svg: exclamationSVG }} />
        </div>
        <div className={b('message')}>{message}</div>
      </div>
    </div>
  )
}

export default SuccesMessage